import React, {useMemo} from 'react';
import {useBadgeMasterData} from "../../logs/useTableData";
import {Button} from "antd";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import TablePage from "../../../pages/tablePage/TablePage";
import {BadgeMasterEntity} from "./BadgeMasterEntity";
import {BadgeMasterTableEntity} from "./BadgeMasterTableEntity";
import {saveBadgeMaster} from "./useBadgeMaster";

const BadgeTable = () => {
    const {data: badgeMaster, isLoading, error} = useBadgeMasterData();

    const handleSave = async (record) => {
        const row = new BadgeMasterEntity(record);
        if (row.isInvalidate()) return;
        await saveBadgeMaster(row.toJson());
    }

    const columns = useMemo(() => [
        {
            title: '뱃지 인덱스',
            dataIndex: 'index',
            key: 'index',
            sorter: (a, b) => a.index - b.index,
        },
        {
            title: '뱃지 이름',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '액션',
            render: (record) => (
                <Button onClick={() => handleSave(record)}>
                    {'추가하기'}
                </Button>
            )
        }
    ], []);

    if (isLoading) return <IsLoading/>;
    if (error) return <ErrorPage error={error}/>;

    const props = {
        columns,
        isLoading,
        localData: badgeMaster || [],
        entityModel: BadgeMasterTableEntity,
    }

    return (
        <TablePage
            {...props}
        />
    );
};

export default BadgeTable;